import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PresignedS3UploadDataFragment = { __typename?: 'PresignedS3PostData', url: string, mediaDomain: string, fields: { __typename?: 'PresignedS3PostDataFields', key: string, xAmzAlgorithm: string, xAmzCredential: string, xAmzDate: string, xAmzSignature: string, xAmzSecurityToken: string, policy: string } };

export type GeneratePresignedS3PostDataMutationVariables = Types.Exact<{
  key: Types.Scalars['String']['input'];
  contentType: Types.Scalars['String']['input'];
  bucket: Types.PresignedS3PostDataBucket;
}>;


export type GeneratePresignedS3PostDataMutation = { __typename?: 'Mutation', generatePresignedS3PostData: { __typename?: 'PresignedS3PostDataMutationResult', success: boolean, data?: { __typename?: 'PresignedS3PostData', url: string, mediaDomain: string, fields: { __typename?: 'PresignedS3PostDataFields', key: string, xAmzAlgorithm: string, xAmzCredential: string, xAmzDate: string, xAmzSignature: string, xAmzSecurityToken: string, policy: string } } | null, error?: { __typename?: 'Error', code: string } | null } };

export const PresignedS3UploadDataFragmentDoc = gql`
    fragment PresignedS3UploadData on PresignedS3PostData {
  url
  mediaDomain
  fields {
    key
    xAmzAlgorithm
    xAmzCredential
    xAmzDate
    xAmzSignature
    xAmzSecurityToken
    policy
  }
}
    `;
export const GeneratePresignedS3PostDataDocument = gql`
    mutation GeneratePresignedS3PostData($key: String!, $contentType: String!, $bucket: PresignedS3PostDataBucket!) {
  generatePresignedS3PostData(
    key: $key
    contentType: $contentType
    bucket: $bucket
  ) {
    success
    data {
      ...PresignedS3UploadData
    }
    error {
      code
    }
  }
}
    ${PresignedS3UploadDataFragmentDoc}`;
export type GeneratePresignedS3PostDataMutationFn = Apollo.MutationFunction<GeneratePresignedS3PostDataMutation, GeneratePresignedS3PostDataMutationVariables>;

/**
 * __useGeneratePresignedS3PostDataMutation__
 *
 * To run a mutation, you first call `useGeneratePresignedS3PostDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresignedS3PostDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresignedS3PostDataMutation, { data, loading, error }] = useGeneratePresignedS3PostDataMutation({
 *   variables: {
 *      key: // value for 'key'
 *      contentType: // value for 'contentType'
 *      bucket: // value for 'bucket'
 *   },
 * });
 */
export function useGeneratePresignedS3PostDataMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePresignedS3PostDataMutation, GeneratePresignedS3PostDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePresignedS3PostDataMutation, GeneratePresignedS3PostDataMutationVariables>(GeneratePresignedS3PostDataDocument, options);
      }
export type GeneratePresignedS3PostDataMutationHookResult = ReturnType<typeof useGeneratePresignedS3PostDataMutation>;
export type GeneratePresignedS3PostDataMutationResult = Apollo.MutationResult<GeneratePresignedS3PostDataMutation>;
export type GeneratePresignedS3PostDataMutationOptions = Apollo.BaseMutationOptions<GeneratePresignedS3PostDataMutation, GeneratePresignedS3PostDataMutationVariables>;